// extracted by mini-css-extract-plugin
module.exports = {"container":"_2RUM-CXuKIf8QVvLYBmGfa","box":"_3COxVoNwTYUxfBrwAme5m-","text":"CDdmNHo1oDSQSv9hM8R5R","meme":"_12ASG4nQgIZhYQ-unJPWA5"};